/* ================================================== */
/* COOKIE BANNER
/* ================================================== */

$(document).ready(function() {
	var $cookieBanner = $('#cookie-banner'),
		name = 'cookieconsent_status',
		duration = 365;

	if ($cookieBanner.length && typeof Cookies.get(name) === 'undefined') {
		gsap.fromTo($cookieBanner, { y: '25%', opacity: 0 }, { y: 0, opacity: 1, duration: 0.3, delay: 1.75 });

		$('.cookie-banner-button', $cookieBanner).click(function() {
			// Hide banner
			gsap.to($cookieBanner, { y: '200%', opacity: 0, duration: 0.3 });

			// Apply cookie
			Cookies.set(name, 'allow', { expires: duration });
		});
	}
});